(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.initThemeSwitch();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.themeObserver) this.themeObserver.disconnect();
      if (this.onThemeResize) window.removeEventListener('resize', this.onThemeResize);
      if (this.onThemeLoad) window.removeEventListener('load', this.onThemeLoad);
    }

    initThemeSwitch() {
      this.sections = Array.from(document.querySelectorAll('.shopify-section')).filter(
        (s) => !s.classList.contains('section-header')
      );
      this.buildThemeObserver();
      this.onThemeResize = debounce(() => {
        this.setHeaderHeight();
        this.buildThemeObserver();
      }, 150);
      window.addEventListener('resize', this.onThemeResize);
      this.onThemeLoad = () => this.applyHeaderTheme();
      window.addEventListener('load', this.onThemeLoad, { once: true });
    }

    buildThemeObserver() {
      if (this.themeObserver) this.themeObserver.disconnect();
      const center = this.offsetHeight / 2;
      const bottom = Math.max(window.innerHeight - center - 1, 0);
      this.themeObserver = new IntersectionObserver(this.applyHeaderTheme.bind(this), {
        rootMargin: `-${center}px 0px -${bottom}px 0px`,
        threshold: 0,
      });
      this.sections.forEach((section) => this.themeObserver.observe(section));
      requestAnimationFrame(() => this.applyHeaderTheme());
    }

    resolveTheme() {
      const center = this.offsetHeight / 2;
      for (const section of this.sections) {
        const rect = section.getBoundingClientRect();
        if (rect.top <= center && rect.bottom >= center) {
          return getComputedStyle(section).getPropertyValue('--header-theme').trim();
        }
      }
      // セクション間マージンやコンテンツ先頭の余白＝ページ背景が露出している帯。
      // 直前セクションに引きずられず、ページ背景のテーマ（:root 既定 light）で判定する。
      return getComputedStyle(document.body).getPropertyValue('--header-theme').trim();
    }

    applyHeaderTheme() {
      const theme = this.resolveTheme();
      this.classList.toggle('header--on-light', theme !== 'dark');
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
